import React from 'react';
import {
  TextField, Box, Typography, Button, withStyles,
} from '@material-ui/core';
import FormErrorText from '../../../components/atoms/formErrorText/FormErrorText';
import FormTitle from '../../../components/atoms/formTitle/FormTitle';
import TabPanel from '../../../components/atoms/tabPanel/TabPanel';
import { getRentalCourtDatas, compareTime, checkValidation } from './rule-list-func';
import Validation from './validation';

const styles = () => ({
  ruleLabel: {
    position: 'relative',
    top: '25px',
    left: '10px',
  },
});

class RentalCourtRules extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      messages: getRentalCourtDatas(),
      data: getRentalCourtDatas(),
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      if (this.props.value === 3) {
        this.setData(this.props.data);
      }
    }
  }

  setData = (data) => {
    this.setState({ data: data || getRentalCourtDatas(), messages: getRentalCourtDatas() });
  }

  onChange = (event) => {
    const { data, messages } = this.state;
    const { value, name } = event.target;
    let tempMessage = { ...messages, [name]: Validation.formValidate(name, value) };

    if (name === 'startTime' && value && data.endTime) {
      tempMessage = compareTime(tempMessage, value, data.endTime);
    }
    if (name === 'endTime' && value && data.startTime) {
      tempMessage = compareTime(tempMessage, data.startTime, value);
    }

    this.setState({
      data: { ...data, [name]: value },
      messages: tempMessage,
    });
  }

  onSave = (event) => {
    const { data, messages } = this.state;
    const errObj = checkValidation(data, messages);
    this.setState({ messages: errObj.messages });
    if (errObj.isError) return;
    this.props.onSave(event, data);
  }

  render() {
    const {
      value, classes,
    } = this.props;
    const { data, messages } = this.state;

    return (
      <TabPanel value={value} index={3}>
        <Box p={2}>
          <Box textAlign="right">
            <Button onClick={this.onSave} color="primary" size="medium">保存する</Button>
          </Box>
          <Box m={3} display="flex">
            <Box>
              <FormTitle title="予約カレンダー表示開始時間" isRequired />
              <TextField
                type="time"
                variant="outlined"
                name="startTime"
                className={classes.timeInput}
                value={data.startTime}
                onChange={this.onChange}
                error={messages.startTime !== ''}
              />
              <FormErrorText>{messages.startTime}</FormErrorText>
            </Box>
            <Box ml={5}>
              <FormTitle title="予約カレンダー表示終了時間" isRequired />
              <TextField
                type="time"
                variant="outlined"
                name="endTime"
                className={classes.timeInput}
                value={data.endTime}
                onChange={this.onChange}
                error={messages.endTime !== ''}
              />
              <FormErrorText>{messages.endTime}</FormErrorText>
            </Box>
          </Box>
          <Box m={3}>
            <FormTitle title="予約受付締切日" isRequired />
            <TextField
              variant="outlined"
              name="closeDay"
              value={data.closeDay}
              onChange={this.onChange}
              error={messages.closeDay !== ''}
              inputProps={{ maxLength: 2 }}
            />
            <Typography className={classes.ruleLabel} component="span">日前</Typography>
            <FormErrorText>{messages.closeDay}</FormErrorText>
          </Box>
          <Box m={3}>
            <FormTitle title="キャンセル可能期限日" isRequired />
            <TextField
              variant="outlined"
              name="cancelDay"
              value={data.cancelDay}
              onChange={this.onChange}
              error={messages.cancelDay !== ''}
              inputProps={{ maxLength: 2 }}
            />
            <Typography className={classes.ruleLabel} component="span">日前</Typography>
            <FormErrorText>{messages.cancelDay}</FormErrorText>
          </Box>
          <Box m={3}>
            <FormTitle title="事前予約可能数" isRequired />
            <TextField
              variant="outlined"
              name="advanceNumber"
              value={data.advanceNumber}
              onChange={this.onChange}
              error={messages.advanceNumber !== ''}
              inputProps={{ maxLength: 8 }}
            />
            <FormErrorText>{messages.advanceNumber}</FormErrorText>
          </Box>
          <Box mt={1}>
            <FormTitle title="予約ルール" />
            <TextField
              id="memberRule"
              name="memberRule"
              multiline
              fullWidth
              rows={25}
              variant="outlined"
              value={data.memberRule}
              onChange={this.onChange}
              inputProps={{
                maxLength: 30000,
              }}
            />
          </Box>
        </Box>
      </TabPanel>
    );
  }
}

export default withStyles(styles)(RentalCourtRules);
